module.exports = "/_next/static/images/4d509e95212eaf7d4ec0f25271aa5a1e-youtube.svg";